import React from 'react';
import { Button, Select, DatePicker } from 'components';

interface Props {
	onClose: () => void;
	onSubmit: (form: any) => Promise<void> | void;
	item?: any;
}

// **Ajuste:** Los valores ahora representan los level_ids que el backend esperaría.
// 'all' es un caso especial que manejaremos en el submit.
const CLIENT_TYPES = [
	{ value: 'all', label: 'Todos' },
	{ value: '5', label: 'Usuario' },
	{ value: '4', label: 'Afiliado' },
	{ value: '3', label: 'Vendedor' },
];

class CreateNotification extends React.Component<Props> {
	state = {
		form: {
			client_type: this.props.item?.client_type || 'all',
			// **Ajuste:** Usar 'date' para coincidir con el backend
			date: this.props.item?.date || '',
			message: this.props.item?.message || '',
		},
		submitting: false,
	};

	componentDidUpdate(prevProps: Props) {
		if (prevProps.item !== this.props.item && this.props.item) {
			this.setState({
				form: {
					client_type: this.props.item.client_type || 'all',
					// **Ajuste:** Usar 'date'
					date: this.props.item.date || '',
					message: this.props.item.message || '',
				},
			});
		}
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value,
			},
		});
	};

	changeDate = (field: string, value: any) => {
		const dateValue = value && value.target ? value.target.value : value;
		this.setState({
			form: {
				...this.state.form,
				[field]: dateValue,
			},
		});
	};

	isValid = () => {
		const { client_type, date, message } = this.state.form;
		// **Ajuste:** Validar 'date'
		return !!client_type && !!date && !!message.trim();
	};

	submit = async (e: any) => {
		e.preventDefault();
		if (!this.isValid() || this.state.submitting) return;

		this.setState({ submitting: true });
		try {
			const { client_type, date, message } = this.state.form;

			// **Ajuste Clave:** Transformar client_type en level_ids para el backend (StoreParams)
			let level_ids: number[] = [];
			const allClientTypes = CLIENT_TYPES.filter(t => t.value !== 'all');

			if (client_type === 'all') {
				// Si es 'Todos', enviar todos los level_ids
				level_ids = allClientTypes.map(t => parseInt(t.value, 10));
			} else {
				// Si es un tipo específico, enviar solo ese level_id
				level_ids = [parseInt(client_type, 10)];
			}

			// El payload a enviar debe ser { date: string, message: string, level_ids: number[] }
			const payload = {
				date,
				message,
				level_ids,
			};

			await this.props.onSubmit(payload);
			this.props.onClose();
		} finally {
			this.setState({ submitting: false });
		}
	};

	render() {
		const { form, submitting } = this.state;

		return (
			<div id="modal-create-notification">
				<form onSubmit={this.submit}>
					<h3>Nueva notificación</h3>

					<div className="row">
						<div className="col-md-12">
							<Select
								label="Tipo de clientes"
								name="client_type"
								onChange={this.change}
								value={form.client_type}
								options={CLIENT_TYPES}
							/>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6">
							<DatePicker
								label="Fecha"
								// **Ajuste:** Usar 'date'
								name="date"
								value={form.date}
								// **Ajuste:** Usar 'date'
								onChange={(value: any) => this.changeDate('date', value)}
							/>
						</div>
					</div>

					<div className="row">
						<div className="col-md-12">
							<label className="label-textarea">Mensaje</label>
							<textarea
								name="message"
								className="textarea-message"
								value={form.message}
								onChange={this.change}
								rows={6}
								placeholder="Escribe el mensaje de la notificación"
							/>
						</div>
					</div>

					<div className="row row-buttons">
						<div className="col-md-6 text-center">
							<Button type="button" onClick={this.props.onClose}>
								Cerrar
							</Button>
						</div>
						<div className="col-md-6 text-center">
							<Button type="submit" disabled={!this.isValid() || submitting}>
								Enviar
							</Button>
						</div>
					</div>
				</form>
			</div>
		);
	}
}

export default CreateNotification;